<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 6h16M7 12h13M10 18h10" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        <circle cx="4.5" cy="12" r="1.6" stroke="currentColor" stroke-width="1.5" />
        <circle cx="7.5" cy="18" r="1.6" stroke="currentColor" stroke-width="1.5" />
    </svg>
</template>